/* global Loader:true $:true */
/**
 * Custom Select Field
 */

// Utilities
import debug from "debug";
import Mousetrap from '@vendor/mousetrap/mousetrap';
import plugin from '../../lib/plugin';
import { mustache, toCamelCase } from '../../lib/strings';
import { elementAttrtibutesToObject } from '../../lib/objects';


const ZERO = 0;
function NOOP() {
}
const MODULE_NAME = 'app.core/modules/custom-select';
const log = debug(MODULE_NAME);

class CustomSelectPlugin {

    /**
     * [constructor description]
     * @param  {[type]} element [description]
     * @param  {[type]} options [description]
     * @return {[type]}         [description]
     */
    constructor(element, options) {
        log('new instance', element, options);

        this.element = element;
        this.options = options;

        this.configure();

        this.$element = $(element);
        this.value = this.$element.attr('value');
        this.$children = this.$element.children('option');

        log(`upgrading to custom select`, this.$element, this.options);
        this.init();
    }

    /**
     * [configure description]
     * @return {[type]} [description]
     */
    configure () {
        if (this.options.itemTemplateSelector) {
            this.options.itemTemplate = $(this.options.itemTemplateSelector).text();
            log('Using item template', this.options.itemTemplate);
        }
    }

    /**
     * [init description]
     * @return {[type]} [description]
     */
    init () {
        /* Add classname to the original select field */
        this.$element.addClass(this.options.hiddenClassName);
        this.$element.addClass(this.options.formFIeldClassName);

        /**
        * Create some new elements
        */
        this.$wrapper = $('<div/>', {
            class: `${this.options.wrappingClassName} ${this.options.annotateWrappingClasses}`
        });
        this.$select = $('<button/>', {
            class: this.options.inputFieldClassname
        });
        this.$list = $('<div />', {
            class: this.options.optionsListClassname
        });

        /**
        * Wrap select and insert into DOM
        */
        // wrap the new select with a wrapper
        this.$wrapper
            .insertAfter(this.$element)
            .append(this.$select)
            .append(this.$list)
            .append(this.$element);

        // has lost it's DOM association, so we need to assign it again.
        // this.$wrapper = this.$select.parent(`.${this.options.wrappingClassName}`);
        // this.$list = this.$select.next(`.${this.options.optionsListClassname}`);

        // Create new custom styled options
        this.$children.each( (index, element) => this.createItem(index, element) );

        // No interaction if only one option
        if (this.$children.length > 1) {
            this.bindEvents();
        }

        this.setDefaultOption();

        this.setSingleOptionState();
    }

    /**
     * Properties
     */

    /**
     * Custom Items collection
     * @return {Jquery Collection}
     */
    get items () {
        return this.$wrapper.find(`.${this.options.optionsListItemClassname}`);
    }

    /**
     * [isFocused description]
     * @return {Boolean} [description]
     */
    get isFocused () {
        return this.$wrapper.is(this.options.activeClassname) || false;
    }

    get value () {
        return this.$element.val();
    }

    set value (value) {
        return this.$element.val(value);
    }

    /**
     * Events
     */
    bindEvents () {
        $(document).on('click', this.hideAllCustomSelect.bind(this));
        Mousetrap.bind('esc', this.hideAllCustomSelect.bind(this));
        this.$select.on('click', this.onSelectClick.bind(this));
        this.$element.on('click', this.onSelectClick.bind(this));

        if (this.options.disableOnEvent) {
            log(`Listening for ${this.options.disableOnEvent}`);
            $(document).on(this.options.disableOnEvent, this.onDisableEvent.bind(this));
        }

        // ugh
        const self = this;
        this.$wrapper.on('click',
                `.${this.options.optionsListItemClassname}`,
                function (event) {
                    self.onItemClick(event, this);
                });

    }

    onSelectClick (event) {

        log('select clicked', this.$select);
        event.preventDefault();
        event.stopPropagation();

        $(`.${this.options.wrappingClassName}.${this.options.activeClassname}`)
            .not(this.$wrapper)
            .each((index, item) => {
                $(item).removeClass(this.options.activeClassname);
            });

        this.$wrapper
            .toggleClass(this.options.activeClassname);
    }

    onDisableEvent (event, doEnable) {
        console.log('doEnable', doEnable);

        if (doEnable && this.$children.length > 1) {
            this.$select.removeAttr('disabled');
        } else {
            this.$select.attr('disabled', 'disabled');
        }

    }

    onItemClick (event, item) {
        const $item = $(item);
        const context = $item.data('context');
        event.stopPropagation();

        log(`clicked item`, $item);
        if (this.value !== $item.attr('rel')) {

            this.value = $item.attr('rel');
            this.$element.val(this.value);
            this.$element.trigger('change');
            this.setDisplayItem($item);
            if (context.href) {
                log('navigating to custom select item href', context.href);
                var page_y = $(window).scrollTop();
         		this.setProductDetailScrollPositionCookie(page_y);
                window.location.href = context.href;
            }
        }

        this.$wrapper.removeClass(this.options.activeClassname);
    }

    setProductDetailScrollPositionCookie(scrollPos) {
    	var cname = this.options.productDetailScrollCookieName;
    	var cvalue = scrollPos;
    	var d = new Date();
	    d.setTime(d.getTime() + (1*24*60*60*1000));
	    var expires = "expires="+ d.toUTCString();
	    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    /**
     * Methods
     */

    /**
     * [createItem description]
     * @param  {[type]} index   [description]
     * @param  {[type]} element [description]
     * @return {[type]}         [description]
     */
    createItem (index, element) {
        const $item = $(element);
        const itemAttrs = elementAttrtibutesToObject($item,
          // filter fn
          () => true,
          // attribute name transform fn
          (name) => toCamelCase(name.replace('data-', ''))
        );
        var isAvailable = typeof(itemAttrs.available) !== 'undefined' ? itemAttrs.available =='True' : true;
        var unavailableClass = isAvailable ? "" : this.options.itemUnavailableClassname;
        const itemContext = Object.assign(itemAttrs, {
          text: $item.text(),
          labelclass: unavailableClass,
          index
        });
        
        const newItem = mustache(this.options.itemTemplate, itemContext);
        log('templated new item', this.options.itemTemplate, 'with context', itemContext, 'result', newItem);
        const $newItem = $(newItem);

        $newItem.attr('data-custom-select-item');
        $newItem.attr('rel', $item.val());
        $newItem.data('context', itemContext);
        $newItem.addClass(this.options.optionsListItemClassname);
        $newItem.appendTo(this.$list);
        log(`Creating new item`, this.$list);
    }

    /**
     * [setDefaultOption description]
     * Find the selected option or select the first one.
     */
    setDefaultOption () {
        const value = this.$element.attr('value');
        const values = Array.from(this.items)
            .map((item) => $(item).attr('rel'));
        const DefaultItemIndex = values.indexOf(value);

        log('setDefaultOption', {value, DefaultItemIndex, values});

        this.setDisplayItem(this.items.get(DefaultItemIndex || ZERO));
    }

    /**
     * [setSingleOptionState description]
     * Set button to disabled state if only one option
     */
    setSingleOptionState () {
        if (this.$children.length === 1) {
            log('Single option only');
            this.$select.attr('disabled', 'disabled');
        }
    }

    /**
     * [setDisplayItem description]
     * @param {[type]} element [description]
     */
    setDisplayItem (element) {
        log('Setting display item', element);
        this.$select.html($(element).html());
    }

    /**
     * [hideAllCustomSelect description]
     * @return {[type]} [description]
     */
    hideAllCustomSelect () {
        log('hiding all custom-selects');

        $(`.${this.options.wrappingClassName}.${this.options.activeClassname}`)
            .data('focused', false)
            .each((index, item) => {
                $(item).removeClass(this.options.activeClassname);
            });
    }


    /**
     * [HighlightItem description]
     * @param {String} direction [description]
     */
    highlightItem(direction = 'down') {
        const $items = this.$list.children(`.${this.options.optionsListItemClassname}`);

        let current = $items.find(`.${options.optionsListItemFocusedClassname}`);
        $items.removeClass(this.options.optionsListItemFocusedClassname);

        log(`moving focus ${direction} from`, current, `between`, $items);
        if (direction === 'down') {
            current = current.next();
        } else {
            current = current.prev();
        }

        log('focusing', current);
        current.addClass(this.options.optionsListItemFocusedClassname);
    }

    /**
     * [SelectItem description]
     */
    selectItem () {
        if (this.isFocused) {
            this.items.find(':focus').trigger('click');
        }
    }
}

CustomSelectPlugin.DEFAULTS = {
    wrappingClassName: 'custom-select',
    annotateWrappingClasses: '',
    hiddenClassName: 'is-hidden',
    formFieldClassName: 'custom-select__input',
    inputFieldClassname: 'custom-select__display',
    optionsListClassname: 'custom-select__list',
    optionsListItemClassname: 'custom-select__item',
    optionsListItemFocusedClassname: 'custom-select__item--focused',
    itemUnavailableClassname : 'custom-select__item-label--unavailable',
    activeClassname: 'custom-select--active',
    itemTemplate: '<div rel="{{rel}}"><span class="custom-select__item-inner"><span class="custom-select__item-label {{labelclass}}">{{text}}</span></span></div>',
    itemTemplateSelector: null,
	productDetailScrollCookieName : 'str001.ProductDetailScrollPosition',
    onSelectFn: NOOP
};

plugin('customSelect', CustomSelectPlugin);


export function exec() {
  $(document).ready(() => {
    $('select[data-custom-select]').customSelect();
  });
}


// WEBPACK FOOTER //
// ./project/client/src/core/modules/custom-select/index.js